import * as React from 'react';

import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/utils';

const badgeVariants = cva(
  'focus:ring-ring inline-flex items-center rounded-md px-2 py-0 text-[10px] leading-4 font-semibold transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-none',
  {
    variants: {
      variant: {
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80 border-transparent',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/80 border-transparent',
        outline: 'border-background border-[1px] text-gray-400',
        default: 'border border-transparent bg-gray-400/20 text-white hover:bg-gray-300/30',
        error: 'border border-red-500/80 bg-red-400/40 text-white hover:bg-red-300/30',
        success: 'border border-green-500/80 bg-green-400/40 text-white hover:bg-green-300/30',
        pending: 'border border-orange-500/80 bg-orange-400/40 text-white hover:bg-orange-300/30',
        warning: 'border border-yellow-500/80 bg-yellow-400/40 text-white hover:bg-yellow-300/30',
        info: 'border border-blue-500/80 bg-blue-400/40 text-white hover:bg-blue-300/30',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
